import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import SeeMore from "../SeeMore/SeeMore";
var WithSeeMore = function(param) {
    var story = param.story, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            story.seeMore && /*#__PURE__*/ _jsx("div", {
                style: {
                    position: "absolute",
                    margin: "auto",
                    bottom: 0,
                    zIndex: 9999,
                    width: "100%",
                    height: "auto"
                },
                children: /*#__PURE__*/ _jsx(SeeMore, {
                    seeMoreContent: story.seeMore
                })
            })
        ]
    });
};
export default WithSeeMore;
